import "flag-icons/css/flag-icons.min.css";
import type { FC } from "react";
import { cn } from "@/utils/cn";

export interface FlagIconProps {
  /** Additional CSS classes */
  className?: string;
}

/**
 * United Kingdom (Great Britain) flag icon
 * Uses the flag-icons library for consistent flag rendering
 *
 * Note: Icon is marked aria-hidden as it's always used with accompanying
 * text labels or within labeled controls (parent elements provide accessibility).
 */
export const GBFlagIcon: FC<FlagIconProps> = ({ className }) => {
  return (
    <span
      aria-hidden="true"
      className={cn("fi fi-gb inline-block", className)}
    />
  );
};

/**
 * United States flag icon
 * Uses the flag-icons library for consistent flag rendering
 *
 * Note: Icon is marked aria-hidden as it's always used with accompanying
 * text labels or within labeled controls (parent elements provide accessibility).
 */
export const USFlagIcon: FC<FlagIconProps> = ({ className }) => {
  return (
    <span
      aria-hidden="true"
      className={cn("fi fi-us inline-block", className)}
    />
  );
};
